import React, { useState, useEffect } from "react";
import "../css/HeroSection.css"; // Your existing styles
import image1 from "../assets/01.png"; // Replace with your image paths
import image2 from "../assets/02.png";
import image3 from "../assets/03.png";
import image4 from "../assets/04.png";
import image5 from "../assets/05.png";
import Lottie from "lottie-react";
import greenCheck from "../assets/greencheck.json";
import { useNavigate } from "react-router-dom";

const HeroSection = () => {
  const images = [image1, image2, image3, image4, image5]; // Array of images
  const [currentImageIndex, setCurrentImageIndex] = useState(0); // Current image index
  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 3000); // Change image every 3 seconds

    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, [images.length]);

  const handleQuizClick = () => {
    navigate('/tax-quiz');
  };

  return (
    <section className="hero-section">
      <div className="content-wrapper">
        {/* Left Side: Text */}
        <div className="hero-text">
          <h2>
            turn tax <span className="hero-text-drains">DRAINS</span>
          </h2>
          <h2>
            into financial <span className="hero-text-gains">GAINS</span>
          </h2>
          {/* <h2>Meet Automated Tax-Loss Harvesting.</h2> */}
          <p>
            ProfiTree is a FinTech product built to help everyday investors
            save thousands in taxes on their stock market investments.
          </p>
          {/* Add CTA Button */}
          <div className="hero__cta-container">
            <button
              className="cta-secondary-button"
              onClick={() => {
                window.location.href = "/signup"; // Replace with your sign-up URL
              }}
            >
              Start my tax savings journey
            </button>

            {/* <button
              className="cta-secondary-button"
              onClick={() => {
                window.location.href = "/learning"; // Replace with your learn TLH URL
              }}
            >
              Learn More on TLH
            </button> */}

            {/*
            <button className="cta-button secondary-button" onClick={handleQuizClick}>
              Try Free Tax Quiz
            </button>
            */}
          </div>
        </div>

        {/* Right Side: Image Slideshow */}
        <div className="hero-slideshow">
          <img
            src={images[currentImageIndex]}
            alt="ProfiTree Slideshow"
            className="slideshow-image"
          />
        </div>
      </div>
      <div className="hero-bottom-border"></div>
    </section>
  );
};

export default HeroSection;
